import { defineKind } from "./base";

/** A photo: the full-screen viewer on walls, the image on a cast (it never ends by itself). */
export const photo = defineKind({
  id: "photo",
  types: ["PHOTO"],
  surface: "photo",
  icon: "image",
  caps: { queueable: true, gallery: true },
  label: (t) => t("cast_item_photo", "Photo"),
  // The wall row's meta names no provider for a photo.
  meta: () => "",
  typeLabel: (t) => t("wall_item_photo", "Photo"),
  // A wall photo has its photo_url; a cast queue item carries it as its url.
  playUrl: (item) => item.photoUrl || item.url || null,
  sourceUrl: (item) => item.photoUrl || null,
  slot: { mediaType: "IMAGE", fallback: true },
});
